(function ($) {

    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 100,
        effect : "fadeIn"
    });

    function refresh_size_queries() {
        var classes = [];
        var scrollbarwidth = getScrollbarWidth();
        window_width = $(window).width() + scrollbarwidth;
        window_height = $(window).height();
        is_less_phone = (window_width <= 414);
        is_phone = (window_width <= 768);
        is_mobile = (window_width <= 992);
        is_landscape = (window_width <= 1024);
        is_tablet_portrait = (window_width > 768 && window_width < 992);
        is_tablet_landscape = (window_width >= 992 && window_width < 1200 && window_height <= 768);
        is_tablet = is_tablet_portrait || is_tablet_landscape;
        is_desktop = (window_width >= 1200);
        is_between_desktop_and_mobile = (window_width < 1200 && window_width > 768);
        is_desktop_large = (window_width >= 1367);
        is_desktop_xxl = (window_width >= 1700 && window_height >= 800);

        if (is_less_phone) {
            classes.push('mq_less_phone');
        }
        if (is_phone) {
            classes.push('mq_phone');
        }
        if (is_mobile) {
            classes.push('mq_mobile');
        }
        if (is_tablet_portrait) {
            classes.push('mq_tablet_portrait');
        }
        if (is_tablet_landscape) {
            classes.push('mq_tablet_landscape');
        }
        if (is_tablet) {
            classes.push('mq_tablet');
        }
        if (is_desktop) {
            classes.push('mq_desktop');
        }
        if (is_desktop_large) {
            classes.push('mq_desktop_large');
        }
        if (is_desktop_xxl) {
            classes.push('mq_desktop_xxl');
        }


        $('html').removeClass('mq_less_phone');
        $('html').removeClass('mq_phone');
        $('html').removeClass('mq_mobile');
        $('html').removeClass('mq_tablet_portrait');
        $('html').removeClass('mq_tablet_landscape');
        $('html').removeClass('mq_tablet');
        $('html').removeClass('mq_desktop');
        $('html').removeClass('mq_desktop_xxl');

        $('html').addClass(classes.join(' '));

        if(navigator.userAgent.match(/iPhone/)) {
            $('html').addClass('iphone');
        }
    }

    function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    function headerPosition() {
        var header = $('#header');
        var headerHeight = $('#top_bar').height();
        var scroll = $(window).scrollTop();

        if (scroll > headerHeight) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }

        var anchor_menu = $('#anchor_menu');
        if(anchor_menu.length > 0){
            var anchor_header_height = $('#header_wrapper').height() + $('#main_slideshow').height() - $('#anchor_menu').height();
            if(scroll > anchor_header_height){
                anchor_menu.addClass('fixed');
            } else {
                anchor_menu.removeClass('fixed');
            }
        }
    }


    function pullman_bercy_sidebarmenu() {
        var link = $('#open_menu_desktop, #open_menu_mobile');
        var wrap = $('#menu_sidebar_wrap');
        var close = wrap.find('.close_sidebar');

        var submenus = wrap.find('.menu-item-has-children');
        submenus.each(function(){
            $(this).append('<span class="dropdown"></span>');
        });
        submenus.find('.dropdown').click(function () {
            $(this).toggleClass('rotate');
            $(this).prev().slideToggle();
        });

        if (link.length > 0 && wrap.length > 0) {
            link.on('click', function(){
                $('#menu_sidebar_wrap a').each(function(){
                    $(this).attr('tabindex', 0);
                })

                setTimeout(function () {
                    wrap.addClass('visible');
                    $('html').addClass('no_scroll');

                    openDialog('menu_sidebar_dialog', this);
                    close.focus();
                }, 300);

            });

            close.on('click', function () {
                closeDialog(close[0]);
                wrap.removeClass('visible');
                $('html').removeClass('no_scroll');

                $('#menu_sidebar_wrap a').each(function(){
                    $(this).attr('tabindex', -1);
                });

                link.focus();
            });


            $(document).click(function (event) {
                var closeme = true;
                if ($(event.target).hasClass('default_dialog') || $(event.target).closest($('.menu_sidebar_inner_content')).length > 0) {
                    closeme = false;
                }
                if ($(event.target).closest($('.dropdown')).length > 0) {
                    closeme = false;
                }
                if (closeme) {
                    if (wrap.hasClass('visible')) {
                        wrap.removeClass('visible');
                        $('html').removeClass('no_scroll');
                    }
                    $('#menu_sidebar_wrap a').each(function(){
                        $(this).attr('tabindex', -1);
                    });
                }
            });

        }
    }

    function pullman_bercy_openBookingform(btn) {

        var btn = $(btn);
        var sidebar = $('.bookingform_sidebar_wrap');
        var close = sidebar.find('.close');

        btn.click(function () {

            var header = $('#header');
            var headerHeight = $('#top_bar').height();
            var scroll = $(window).scrollTop();
            var selector = (scroll > headerHeight) ? '.main_book.only_header_fixed' : '.col_right .main_book';

            sidebar.fadeIn(function () {
                sidebar.addClass('visible');
            });
            $('html').addClass('no_scroll');

            openDialog('bookingform_sidebar_dialog', this);

            close.focus();
            console.log('close focused');


            close.click(function () {
                closeDialog(close[0]);

                sidebar.removeClass('visible');
                $(selector).focus();
                sidebar.fadeOut();
                $('html').removeClass('no_scroll');
            });
        });

        $(document).click(function (event) {
            var closeme = true;

            if ($(event.target).closest(btn).length > 0) {
                closeme = false;
            }
            if ($(event.target).hasClass('close_bookingform_dropdown') || $(event.target).hasClass('hasDatepicker') || $(event.target).hasClass('ui-datepicker-next') || $(event.target).hasClass('ui-datepicker-prev')) {
                closeme = false;
            }
            if ($(event.target).closest(sidebar.find('#bookingform_sidebar_dialog')).length > 0) {
                closeme = false;
            }
            if ($(event.target).closest($('.ui-datepicker')).length > 0 || $(event.target).closest($('.ui-datepicker-div')).length > 0) {
                closeme = false;
            }
            if ($(event.target).hasClass('ui-icon-circle-triangle-e')) {
                closeme = false;
            }
            if (closeme) {
                if (sidebar.hasClass('visible')) {
                    sidebar.removeClass('visible');
                    sidebar.fadeOut();
                    $('html').removeClass('no_scroll');
                }
            }
        });
    }


    function pullman_bercy_check_quicksearch(){

        if($('body').hasClass('home')){
            if(!is_mobile) {
                $('.bookingform_sidebar_wrap:not(.visible)').show();
                $('.bookingform_vertical').addClass('bookingform_horizontal').removeClass('bookingform_vertical');

                $('.main_book').click(function(){
                    if($('#main_slideshow').hasClass('playing-video')){
                        $('.controls .stop').trigger('click');
                    }
                    $('html, body').animate({
                        scrollTop: $('form.bookingform').offset().top -120
                    }, 500, function(){
                        $('.input_arrival').focus();
                    });
                });
            } else {
                $('.bookingform_sidebar_wrap:not(.visible)').hide();
                $('.bookingform_horizontal').addClass('bookingform_vertical').removeClass('bookingform_horizontal');

                pullman_bercy_openBookingform('.main_book');
            }
        } else {
            pullman_bercy_openBookingform('.main_book');
        }
    }

    function pullman_bercy_skip_to_content(){
        $('#skip-to-content').on('click keypress', function(e){
            var offset =  0;
            offset = $('#header_wrapper').height();
            $('html, body').animate({
                scrollTop: $('.main_content .the_title').offset().top - offset
            }, 500);

            $('.main_content .the_title').focus();
        });
    }


    function pullman_bercy_offers_preview_carousel_init(){
        var boxes = $('.carousel_preview_offers .do_carousel');
        var boxesWrapper = $('.carousel_preview_offers');
        if(boxesWrapper.length === 0) return false;

        var condition = (boxes.find('.single-child-wrap').size() > 1);

        var autoplay = (! $('body').hasClass('page-template-template-rse'));
        // console.log('autoplay', autoplay, boxes);
        if(condition) {
            boxes.on('init', function (event, slick) {
                lazyLoadInstance.update();

                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    });
                }, 300);
            });

            boxes.on('afterChange', function (event, slick, currentSlide, nextSlide){
                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    })
                }, 300);
            });

            var sliderTimer = ($('body').hasClass('page-template-template-rse'))? 5000 : 2000;
            boxes.slick({
                rows: 0,
                centerMode: false,
                slidesToShow: 1,
                dots: true,
                arrows: true,
                autoplay: autoplay,
                autoplaySpeed: sliderTimer,
                speed: 1500,
                infinite: true,
                variableWidth: false,
                lazyLoad: 'progressive',
                nextArrow: boxesWrapper.find('.container_carousel .next'),
                prevArrow: boxesWrapper.find('.container_carousel .prev'),
                accessibility: true,
            });

            function progressBar(){
                $('.slider-progress').find('span').removeAttr('style');
                $('.slider-progress').find('span').removeClass('active');
                setTimeout(function(){
                    $('.slider-progress').find('span').css('transition-duration', (sliderTimer/1000)+'s').addClass('active');
                }, 1500);
            }
            progressBar();
            boxes.on('beforeChange', function(e, slick) {
                progressBar();
            });

        }
    }


    function pullman_bercy_mobile_news_carousel_init(){
        var boxes = $('.one_line_elements, .container_posts');
        var boxesWrapper = $('#children-list, .container_other_posts_preview');
        if(boxesWrapper.length === 0) return false;

        var condition = (boxes.find('.single-child-wrap').size() > 1);

        if(condition) {
            boxes.on('init', function (event, slick) {
                lazyLoadInstance.update();

                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    });
                }, 300);
            });

            boxes.on('afterChange', function (event, slick, currentSlide, nextSlide){
                setTimeout(function(){
                    boxes.find('a.title-link').each(function(){
                        $(this).attr('tabindex','-1');
                    })
                }, 300);
            });

            boxes.slick({
                rows: 0,
                centerMode: false,
                slidesToShow: 1,
                dots: true,
                arrows: true,
                autoplay: false,
                speed: 1500,
                infinite: true,
                variableWidth: false,
                lazyLoad: 'progressive',
                nextArrow: boxesWrapper.find('.container_carousel .next'),
                prevArrow: boxesWrapper.find('.container_carousel .prev'),
                accessibility: true,
            });
        } else {
            if(is_mobile){
                boxesWrapper.find('.arrow').hide();
            }
        }
    }

    function pullman_bercy_rse_addtional_content_carousel_init(){

        $('.flip_card').each(function(){
            var card = $(this);
            var button_flip = $(this).find('.button');
            console.log('fpli card', card, button_flip);
            var close_flip = $(this).find('.close');
            button_flip.on('click keypress', function(e){
                button_flip.attr('tabindex', -1);
                close_flip.attr('tabindex', 0).focus();
                card.addClass('rotateme');
            });
            close_flip.on('click keypress', function(e){
                card.removeClass('rotateme');
                close_flip.attr('tabindex',-1);
                button_flip.attr('tabindex',0).focus();
            });
        })

        var boxes = $('.additional_elem_carousel');
        var boxesWrapper = $('#additional-list');
        if(boxesWrapper.length === 0) return false;

        var condition = (boxes.find('.single-child-wrap').size() > 1);

        if(condition) {
            boxes.on('init', function (event, slick) {
                lazyLoadInstance.update();

                setTimeout(function(){
                    boxes.find('a.close').each(function(){
                        $(this).attr('tabindex','-1');
                    });
                }, 300);
            });

            boxes.slick({
                rows: 0,
                centerMode: false,
                slidesToShow: 3,
                dots: true,
                arrows: true,
                autoplay: false,
                speed: 1500,
                infinite: false,
                lazyLoad: 'progressive',
                nextArrow: boxesWrapper.find('.container_carousel .next'),
                prevArrow: boxesWrapper.find('.container_carousel .prev'),
                accessibility: true,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });
        } else {
            if(is_mobile){
                boxesWrapper.find('.arrow').hide();
            }
        }


    }


    function pullman_bercy_minigallery_three_elem_init(){
        var minigalleryWrapper = $('.minigallery_three_elements_container');
        if(minigalleryWrapper.length === 0) return false;

        minigalleryWrapper.each(function(){

            var minigallery = $(this).find('.minigallery_three_elements');

            if( minigallery.find('.slide').size() > 3  || (is_phone && minigallery.find('.slide').size() > 1)) {
                var prev_next_btn = (minigallery.find('.slide').size() > 3 || is_phone)? true : false;

                minigallery.on('init', function(event, slick){
                    lazyLoadInstance.update();

                });

                minigallery.slick({
                    rows: 0,
                    centerMode: false,
                    slidesToShow: 3,
                    dots: prev_next_btn,
                    arrows: prev_next_btn,
                    infinite: true,
                    variableWidth: true,
                    lazyLoad: 'progressive',
                    nextArrow: $(this).find('.next'),
                    prevArrow: $(this).find('.prev'),
                    accessibility: true,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 1,
                                centerMode: true,
                                arrows: true,
                                infinite:true,
                            }
                        },
                    ]
                });
            }
        });



    }

    function pullman_bercy_minigallery_carousel_init(){
        var boxesWrapper = $('.minigallery_container');
        if(boxesWrapper.length === 0) return false;
        boxesWrapper.each(function(){

            var boxes = $(this).find('.minigallery');
            var condition = (boxes.find('.slide').size() > 1);
            var thisboxesWrapper = $(this);

            if(condition) {
                boxes.slick({
                    rows: 0,
                    centerMode: false,
                    slidesToShow: 1,
                    dots: true,
                    arrows: true,
                    speed: 1000,
                    infinite: true,
                    variableWidth: false,
                    lazyLoad: 'progressive',
                    nextArrow: thisboxesWrapper.find('.next'),
                    prevArrow: thisboxesWrapper.find('.prev'),
                    accessibility: true,
                });
            }
        });

    }

    function anchors() {
        var wrap = $('.anchor_menu');
        if (wrap.length > 0) {
            var items = wrap.find('.anchor_label');
            items.each(function () {
                var item = $(this);
                item.click(function (e) {
                    var goTo = '#' + item.attr('data-scroll');
                    var top = $(goTo).offset().top - 150;

                    $('html,body').stop().animate({scrollTop: top}, 500);
                    wrap.find('a').removeClass('active');
                    item.addClass('active');

                    $(goTo).find('.the_title').focus();
                });
            });
        }
    }

    function anchorsAddClass() {
        var anchors = $('.anchor_menu'),
            header = $('#header_wrapper');
        var headerHeight = header.height();
        var anchorsHeight = anchors.height();
        var closestSection = null;
        if (anchors.length > 0) {
            $('section, main').each(function () {
                var s = $(this);
                var paddingTxt = '';
                if($('section, main').length > 1){
                    paddingTxt = $('section, main').eq(1).css('padding-bottom');
                } else {
                    paddingTxt = $('section, main').css('padding-bottom');
                }
                var padding = paddingTxt.replace('px', '');
                var topPosition = s.offset().top - padding;
                var distance = topPosition - anchorsHeight - headerHeight - $(document).scrollTop() - 1;
                if (distance <= 0) {
                    closestSection = s;
                }
            });
            if (closestSection !== null) {
                var activeSlide = $('.anchor_menu a[data-scroll="' + closestSection.attr('id') + '"]');
                $('.anchor_menu .active').removeClass('active');
                activeSlide.addClass('active');

            }
        }
    }
    function anchorsSlider() {
        var main_wrap = $('.anchor_menu .anchors_wrap');
        if (main_wrap.length > 0) {
            var wrap = main_wrap.find('.wrap');
            var wrap_width = wrap.width();
            var labels = wrap.find('.anchor_label');
            var labels_width = 0;

            /*if (!is_mobile) {*/
            labels.each(function () {
                var label = $(this);
                label_outer_width = label.outerWidth();
                labels_width += label_outer_width;
            });
            if (labels_width > wrap_width) {
                main_wrap.addClass('slider_is_visible');
                if (!wrap.hasClass('slick-initialized')) {

                    wrap.slick({
                        infinite: false,
                        centerMode: false,
                        variableWidth: true,
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        nextArrow: main_wrap.find('.next'),
                        prevArrow: main_wrap.find('.prev'),
                    });
                }
            } else {
                main_wrap.removeClass('slider_is_visible');
                if (wrap.hasClass('slick-initialized')) {
                    wrap.slick('unslick');
                }
            }

            wrap.on('afterChange', function (e, slick) {
                var lElRect = slick.$slides[slick.slideCount - 1].getBoundingClientRect();
                var rOffset = lElRect.x + lElRect.width;
                var wraRect = $('.slick-list', wrap).get(0).getBoundingClientRect();
                if (rOffset < (wraRect.x + wraRect.width)) {
                    main_wrap.find('.slick-arrow.next').addClass('slick-disabled').attr('disabled', 'disabled').attr('aria-disabled', true).css('z-index', '-1');
                } else {
                    main_wrap.find('.slick-arrow.next').removeClass('slick-disabled').attr('disabled', false).attr('aria-disabled', false).css('z-index', '1');
                }
            });
        }

    }


    function pullman_bercy_manager_on_focus() {
        //This function is for accessibility
        document.addEventListener("keydown", function(event) {
            if(event.which == 9){

                $('.language_selector .current_language').focus(function () {
                    $('#other_languages').css({
                        'display': 'block',
                    });
                });

                $('.other_languages li:last-child a').focusout(function(){
                    $('.other_languages').removeAttr('style');
                });

                //sidebar menu
                $('#open_menu_desktop').focus(function () {
                    var close_sidebar = $('#menu_sidebar_wrap .close_sidebar');

                    $('#primary_menu_sidebar a').focus(function () {
                        $(this).next().css({
                            'display': 'block',
                        });
                    });
                    $('#primary_menu_sidebar .sub-menu li:last-child a').focusout(function(){
                        $('.sub-menu').hide();
                    });
                });

                //last element in the footer, return to the first element in the DOM
                $('footer a:last').focus(function () {
                    $('footer a:last').focusout(function(){
                        $('#skip-to-content').focus();
                    });
                });

                //popup allsafe
                $('._allsafe_link').focus(function (e) {
                    e.preventDefault();
                    $('._allsafe_link').keydown(function (e) {
                        if (e.which == 13) {
                            setTimeout(function(){
                                $('.lightfeather-close-icon').focus();
                                $('._allsafe_popin_link').focus(function (e) {

                                    $('._allsafe_popin_link').focusout(function () {
                                        $('.lightfeather-close-icon').focus();
                                    });

                                });
                            },500);
                        }
                    });
                });

                //instagram feed imahes popup lightbox
                $('.sbi_link_area').focus(function (e) {
                    e.preventDefault();
                    $('.sbi_link_area').keydown(function (e) {
                        var selected_photo = $(this);
                        if (e.which == 13) {
                            setTimeout(function(){
                                $('.sbi_lb-close').focus();
                                $('.sbi_lb-close').keydown(function (e) {
                                    if (e.which == 13) {
                                        setTimeout(function(){
                                            selected_photo.focus();
                                        },2000);
                                    }
                                });
                            },2000);
                        }
                    });
                });
                $('.sbi_photo_wrap a:not(.sbi_photo)').attr('tabindex', -1);
            }
        });


    }


    function pullman_bercy_meeting_table_select() {
        var select_capacity = $('.select_capacity');
        if(select_capacity.length === 0) return false;

        select_capacity.each(function() {
            var table = $(this).closest('.table-container');
            var select_table = $(this);
            var init_value = select_table.val();
            table.find('.flex-table .flex-row.'+init_value).css({display: "flex"});

            select_table.change(function(){
                var changed_val = $(this).val();
                table.find('.flex-table .flex-row:not(.first)').hide();

                table.find('.flex-table .flex-row.'+changed_val).css({display: "flex"});

            });
        });
    }

    function pullman_bercy_number_rows_table(){
        var each_table = $('.meeting_room_capacities');
        if(each_table.length == 0) return false;

        each_table.each(function() {
            var this_table = $(this);
            var rows = this_table.find('.flex-table.row');
            var total_rows = rows.length;
            var more_button = this_table.find('.view_more_rooms');
            var less_button = this_table.find('.hide_more_rooms');

            if(total_rows > 5){
                var index = 0;
                rows.each(function(){
                    if(index < 5){
                        $(this).css('display', 'flex');
                    }
                    index++;
                });

                more_button.show();

                more_button.click(function(){
                    more_button.hide();
                    less_button.show().focus();

                    rows.each(function(){
                        $(this).css('display', 'flex');
                    });

                });

                less_button.click(function(){
                    more_button.show().focus();
                    less_button.hide();

                    var index2 = 1;
                    rows.each(function(){
                        if(index2 > 5){
                            $(this).css('display', 'none');
                        }
                        index2++;
                    });

                })

            } else {
                rows.each(function(){
                    $(this).css('display', 'flex');
                });
            }

        });
    }


    function pullman_bercy_adjust_table_rows(){
        if(is_between_desktop_and_mobile) {
            var each_table = $('.meeting_room_capacities');
            if(each_table.length == 0) return false;

            each_table.each(function(){
                var this_table = $(this);
                var total_capacities = this_table.find('.flex-table.header.hide_mobile .flex-row:not(.first)').length;
                var w_total = this_table.find('.container_table_overflow').width();

                var w_first_row = this_table.find('.flex-table.header.hide_mobile .flex-row.first').outerWidth(true); //padding & margin

                if(total_capacities > 0){
                    var $num_max_rows = (total_capacities >= 9)? 9 : total_capacities;
                    var $width_single_item = (w_total - w_first_row) / $num_max_rows;

                    this_table.find('.flex-table .flex-row:not(.first)').css('width', $width_single_item);
                }
            });

        } else if(is_phone){
            var each_table = $('.meeting_room_capacities');
            if(each_table.length == 0) return false;

            each_table.each(function(){
                var this_table = $(this);
                this_table.find('.flex-table .flex-row:not(.first)').each(function(){
                    $(this).css('width', '45vw');
                })
            });
        }
    }

    function pullman_bercy_opencloseviewmore() {
        var button_readmore = $('.view_more_content');

        button_readmore.on('click tap', function (e) {
            e.stopPropagation();
            // this
            var anchor = $(this);
            var div_id = anchor.data('id');
            // id optional
            var more_text_box = (typeof div_id !== 'undefined') ? $('#' + div_id) : $(this).parent().find('.more_text_box');
            // reset
            if (typeof div_id == 'undefined') {
                var more_text_box_opened = $('.more_text_box.opened');
                if (more_text_box_opened.length > 0) {
                    more_text_box_opened.stop().animate({height: 0}, 300, function () {
                        more_text_box_opened.parent().find('.view_more_content').removeClass('opened');
                        more_text_box_opened.removeClass('opened');
                    });
                }
            }
            if ($(this).hasClass('opened')) {
                more_text_box.stop().animate({height: 0}, 300, function () {
                    anchor.removeClass('opened');
                    more_text_box.removeClass('opened');
                });
            } else {
                var customHeight = more_text_box.find('.more_text').outerHeight(true);
                more_text_box.stop().animate({height: customHeight}, 300, function () {
                    anchor.addClass('opened');
                    more_text_box.addClass('opened');
                });
            }
            //close on btn
            more_text_box.find('.close').on('click tap', function () {
                more_text_box.stop().animate({height: 0}, 300, function () {
                    anchor.removeClass('opened');
                    more_text_box.removeClass('opened');
                });
            });
        });
    }


    function pullman_bercy_main_content_read_more(){
        if(is_phone) {
            var content = $('.mobile_truncated');
            if (content.length == 0) return false;

            var customHeight = content.height();
            var button_more = $('.main_container.full_width').find('.view_more_content');
            if (button_more.length > 0) {

                content.stop().animate({height: 245}, 300, function () {
                    button_more.removeClass('read_all');
                    content.removeClass('read_all');
                });

                button_more.on('click tap', function () {
                    var anchor = $(this);

                    if (content.hasClass('read_all')) {
                        content.stop().animate({height: 245}, 300, function () {
                            anchor.removeClass('read_all');
                            content.removeClass('read_all');
                        });
                    } else {
                        content.stop().animate({height: customHeight}, 300, function () {
                            anchor.addClass('read_all');
                            content.addClass('read_all');
                        });
                    }


                })
            }
        }
    }

    function isotopeHeightBoxes($item){
        var maxHeight = 0;
        var index = 1;
        var elements = [];

        $($item).each(function(){
            console.log($(this));
            if(index == 3){
                // console.log(elements)
                $(elements.toString()).height(maxHeight);
                index = 1;
                maxHeight = 0;
                elements = [];
            }
            if($(this).is(':visible')){
                var thisH = $(this).height();
                if (thisH > maxHeight) { maxHeight = thisH; }
                index++;
                elements.push('#'+ $(this).attr('id'));
            }
        });

        // $($item).height(maxHeight);
    }
    function pullman_bercy_isotope_multiple(){
        // init Isotope
        if(!is_phone){
            isotopeHeightBoxes('.single-child-wrap');
        }

        var gutter_val = (is_landscape)? 40 : 80;
        var $container = $('#pois_preview .children-wrap').isotope({
            itemSelector: '.single-child-wrap',
            percentPosition: true,
            layoutMode: 'fitRows',
            fitRows: {
                gutter: gutter_val
            }
        });

        // filter with selects and checkboxes
        var $checkboxes = $('#pois_filters input');

        $checkboxes.change( function() { //TODO SPACE WITH KEYBOARD
            // map input values to an array
            var inclusives = [];
            // inclusive filters from checkboxes
            $checkboxes.each( function( i, elem ) {
                // if checkbox, use value if checked
                if ( elem.checked ) {
                    inclusives.push( elem.value );
                }
            });

            // combine inclusive filters
            var filterValue = '';
            if($(this).val() === '*'){
                filterValue = '*';
                $checkboxes.each(function(){
                    $(this).prop('checked', false);
                });
                $('input.view_all').prop('checked', true);

            } else {
                if(inclusives.length){
                    filterValue = inclusives.join(', ').replace('*,','');
                    $('input.view_all').prop('checked', false);

                } else {
                    filterValue = '*';
                    $('input.view_all').prop('checked', true);
                }
            }

            $container.isotope({ filter: filterValue });

            if(!is_phone){
                isotopeHeightBoxes('.single-child-wrap' + filterValue);
            }
        });

        $('#select_poi').change(function () {
            $container.isotope({filter: this.value});
        });
    }

    function pullman_bercy_padding_subimages(){
        if($('body').hasClass('page-template-template-restaurants') || $('body').hasClass('page-template-template-meetings') || $('body').hasClass('page-template-template-rooms') || $('body').hasClass('tax-post_rooms_taxonomy') || $('body').hasClass('page-template-template-fitness_spa')){

            setTimeout(function(){

                //images under main minigallery
                if($('.main_container.with_image').length){
                    $('.main_container.with_image').each(function(){
                        var content_height = $(this).find('.content_height .content_container').outerHeight();
                        var images_height = $(this).find('.minigallery_container').outerHeight() + $(this).find('.small_image').outerHeight() - 70;

                        // console.log($(this));
                        // console.log(content_height);
                        // console.log(images_height);
                        if(images_height > content_height){
                            $(this).css('margin-bottom', images_height - content_height);
                        }

                        AOS.refresh();
                    });
                }
            }, 150);
        }
    }


    $(document).ready(function () {

        refresh_size_queries();

        $('body').trigger('click');

        //trigger a user interaction
        // if(is_landscape) {
        //     setTimeout(function(){
        //         $('html, body').animate({
        //             scrollTop: 1
        //         }, 1);
        //         setTimeout(function(){
        //             $('html, body').animate({
        //                 scrollTop: 0
        //             }, 1);
        //         }, 50)
        //     }, 100);
        // }

        headerPosition();

        AOS.init();

        if (window.location.href.indexOf("#") > -1) {
            var anchor_to_scroll = window.location.hash;
            console.log(anchor_to_scroll);
            $('html, body').animate({
                scrollTop: $(anchor_to_scroll).offset().top - 50
            }, 500);
        }

        if(!is_mobile){
            $('.highlight_menu').accessibleMegaMenu({
                openOnMouseover: true,
            });
            setTimeout(function(){
                $('.highlight_menu').removeClass('overflow_hidden');
                $('.highlight_menu .external_div').attr('style', '1');
                // });
            }, 200);
        }

        // hack so that the megamenu doesn't show flash of css animation after the page loads.
        setTimeout(function () {
            $('body').removeClass('init');

            $('.external_div').each(function(){
                var window_with_sidebar = $(window).width();
                var offset_left = $(this).offset().left;
                $(this).css('width', window_with_sidebar );
                $(this).css('left', offset_left * -1 );
            });
        }, 500);


        pullman_bercy_manager_on_focus();

        pullman_bercy_skip_to_content();
        pullman_bercy_sidebarmenu();
        pullman_bercy_check_quicksearch();
        pullman_bercy_opencloseviewmore();
        pullman_bercy_main_content_read_more();

        pullman_bercy_minigallery_three_elem_init();


        if(!is_mobile){
            $('#menu_sidebar_wrap a').each(function(){
                $(this).attr('tabindex', '-1');
            })
        } else {
            $('#menu_sidebar_wrap a').each(function(){
                $(this).attr('tabindex', '0');
            })
        }

        //accessibility aria-expanded
        $( ".language_selector" ).hover(
            function() {
                if($('#other_languages:visible').length > 0){
                    $('.current_language').attr('aria-expanded', 'true');
                } else {
                    $('.current_language').attr('aria-expanded', 'false');
                }
            }, function() {
                $('.current_language').attr('aria-expanded', 'false');
            }
        );

        if($('body').hasClass('home')){

            setTimeout(function(){
                $('img.sbi_lb-image, video.sbi_video').attr('src',  theme_url + '/css/images/placeholder.png');
            }, 150);

            if(!is_phone){
                if($('#map-canvas').length > 0){
                    $('#map-canvas').css('height', $('.container_hp_contacts').outerHeight());
                }
            }

            if(is_mobile){
                pullman_bercy_mobile_news_carousel_init();
            }

        } else {

            $('.anchors_wrap a[href^="#"]').click( function (event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top - 50
                }, 500);
            });
        }

        if($('body').hasClass('single-post')){
            if(is_mobile){
                pullman_bercy_mobile_news_carousel_init();
            }
        }

        //pages with anchor menu
        if($('#anchor_menu').length){
            anchors();

            anchorsSlider();

            anchorsAddClass();

        }

        if(($('body').hasClass('page-template-template-rse') || $('body').hasClass('page-template-default') || $('body').hasClass('blog')) || $('body').hasClass('single-post_special_offers') || $('body').hasClass('page-template-template-rooms') || $('body').hasClass('page-template-template-fitness_spa') || $('body').hasClass('page-template-template-restaurants')){
            pullman_bercy_offers_preview_carousel_init();
        }

        if($('body').hasClass('page-template-template-meetings')){
            pullman_bercy_adjust_table_rows();
            pullman_bercy_number_rows_table()

            if(is_phone) {
                pullman_bercy_meeting_table_select();
            }

        }

        if($('body').hasClass('page-template-template-location')){
            pullman_bercy_isotope_multiple();
        }

        if($('body').hasClass('page-template-template-offers') || $('body').hasClass('blog')){
            if(is_mobile) {
                $('#children-list .not_a_carousel').simpleLoadMore({
                    item: '.single-child-wrap',
                    count: 2,
                    itemsToLoad: 2,
                    btnHTML: '<div class="buttons_container centered"><a class="button load_more_boxes" href="javascript:;" title="'+ load_more_title +'" aria-label="'+ load_more_title +'">'+ load_more_label +'</a></div>',
                });
            }
        }

        //default page
        if($('body').hasClass('page-template-default') && !$('body').hasClass('home')|| $('body').hasClass('blog')){
        var index = 0;
            $('section').each(function(){
                var bg_colored = (index%2 === 0)? 'blue_bg' : 'white_bg';
                $(this).addClass(bg_colored);
                index++;
            })
        }

        //rse page
        if($('body').hasClass('page-template-template-rse')){
            var box_wrapper = $('.tabs-carousel-list');
            $('.tabs_contents').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                asNavFor: '.navigation_tabs',
                rows: 0,
                speed: 1500,
            });
            $('.navigation_tabs').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.tabs_contents',
                dots: false,
                fade: false,
                centerMode: false,
                focusOnSelect: true,
                speed: 1500,
                infinite: true,
                nextArrow: box_wrapper.find('.container_carousel .next'),
                prevArrow: box_wrapper.find('.container_carousel .prev'),
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                ]
            });

            pullman_bercy_rse_addtional_content_carousel_init();
        }

        //video in main content
        if($('#player_main_content').length){

            var player = new Plyr('#player_main_content', {
                volume: 0,
                hideControls: false,
                controls: ['play','stop','pause','mute', 'volume'],
            });
        }


        if($('.minigallery_container').length){
            pullman_bercy_minigallery_carousel_init();
        }

    });

    $(window).scroll(function () {
        headerPosition();

        AOS.refresh();

        if($('#anchor_menu').length){
            anchorsSlider();

            anchorsAddClass();
        }
    });

    $(window).on('load', function () {

        pullman_bercy_padding_subimages();

        $('img').bind('DOMSubtreeModified', function(e) {
            pullman_bercy_padding_subimages();
        });

        if($('body').hasClass('page-template-template-contacts')|| $('body').hasClass('page-template-template-events-contact')){
            $('select[name="contact_service"], select[name="event_type"]').change(function(){
                var option = $('option:selected', this).attr('data-email');

                $('form.deform_contacts, form.deform_events').find('input[name="recipient_id"]').val(option);
            });


            $('input[name="event_arrival_date"]').on("change", function() {
                var date = $(this).val();
                $('input[name="event_departure_date"]').datepicker('option', 'minDate', date);
            });

            //remove browser validation
            setTimeout(function(){
                $('form.deform').attr('novalidate', 'novalidate');
            }, 2000);
        }
    });

    $(window).resize(function () {
        refresh_size_queries();
        pullman_bercy_check_quicksearch();

        if($('body').hasClass('home')){
            if($('#map-canvas').length > 0){
                $('#map-canvas').css('height', $('.container_hp_contacts').outerHeight());
            }
        }

        if($('body').hasClass('page-template-template-meetings')){
            if(is_phone) {
                pullman_bercy_meeting_table_select();
            } else {
                $('.flex-table .flex-row').css({display: "flex"});
            }
        }

    });

})(jQuery);